import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'emailMask' })
export class EmailMaskPipe implements PipeTransform {
	transform(plainEmail: string, visibleCharacters: number = 4): string {
		let atSection = plainEmail.indexOf("@");
		visibleCharacters = atSection;
		let maskedSection1 = plainEmail.slice(1, 4);
		let visibleSection = plainEmail.slice(visibleCharacters, visibleCharacters + 2);
		let maskedSection2 = plainEmail.slice(visibleCharacters
			+ 2, visibleCharacters + 6
		);
		return plainEmail[0] + maskedSection1.replace(/./g, '*') + visibleSection + maskedSection2.replace(/./g, '*');
	}
}